import { Component, ElementRef, ViewChild, effect, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpEvent, HttpEventType, HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { DisputesService } from '../dispute.service';
import { DisputeModalComponent } from '../dispute-modal/dispute-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProfileModalComponent } from '../../profile-layout/profile-modal/profile-modal.component';

@Component({
  selector: 'app-dispute-details',
  templateUrl: './dispute-details.component.html',
  styleUrl: './dispute-details.component.scss'
})
export class DisputeDetailsComponent {
  @ViewChild('imageElement') imgElement!: ElementRef;
  viewId: any;
  mask:any
  contract_data: any;
  contract_documents: any;
  initials: any;
  is_loading: boolean = false;
  disputedPayments: any;
  timezone: any;
  selected_file: any;
  images: any = [];
  doc_note: string = '';
  doc_count: any = 0;
  is_verified: any = 0;
  is_pending : any = 0;
  is_submitted : any = 0
  is_doc_submitted : any = 0
  need_more_documents : any = 0
  country_data: any
  currency_data: any;
  is_any_doc_upload:boolean = false;
  

  constructor(
    public mainService: MainService,
    public router: Router,
    public _ActiveRoute: ActivatedRoute,
    private _local: localStorageService,
    private _api: ApiService,
    public _shared: SharedService,
    private _sanitizer: DomSanitizer,
    private _loader: LoaderService,
    private _dispute: DisputesService,
    private _modalService: BsModalService,
    private injector: Injector
  ) { }

  ngOnInit() {
    this.timezone = this._shared.getCurrentTimezone();
    this._ActiveRoute.queryParams.subscribe(params => {
      this.viewId = params;
     
      this.getcontractListFromId();
    });

    effect(() => {
      const res: any = this._shared.country_currency_info();
      this.country_data = res && res?.country;
      this.currency_data = res && res?.currency && res?.currency[0];
    }, { injector: this.injector, allowSignalWrites: true });

  }
  getcontractListFromId() {
    try {
      // let button = document.querySelector('.buttonlist-toggle');
      // if (button) {
      //   button['blur']();
      // }
      let params;
      params = new URLSearchParams(window.location.search)
      // this.viewId = params.get('id');
      if (!params) return;
      // let userData = this._local.customGetItem('userProfileData')
      // if (userData) {
        let data = {
          // access_token: userData.access_token,
          // doctor_id: userData.doctor_id,
          limit: 10,
          contract_id : Object.values(this.viewId)[0],
          split_req_id : Object.values(this.viewId)[0]
          // offset: this.offset,
          // code: this.selectedDisputes || 0,
        }
        if (Object.keys(this.viewId)[0] == "contract_id") {
          delete data.split_req_id         
        }else{
          delete data.contract_id 
        }
        this._api.api(data, 'disputes/get_doctor_disputes', 'get').subscribe((data: any) => {
          try {
            // if (data.is_error) {
            //   window.location.reload();
            // }
            if (data.is_error) {
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([this.router.url]);
              });
            }
   
            this.contract_data = data.disputed_payments[0];
            this.disputedPayments = data.disputed_payments;
            this.contract_documents = data.documents_required;
            this.contract_documents = this.contract_documents.filter((doc:any) => {return (doc.document_name != null) || doc.doc_url !==""
            })
            if (this.contract_documents.some((doc: any) => doc.is_verified == 1)) {
              this.is_verified = 1;
              // this.contract_documents = this.contract_documents.filter((doc: any) => {
              //   return doc.doc_url !== ""
              // })
            }
            if (this.contract_documents.some((doc: any) => doc.is_submitted == 1 )) {
              this.is_submitted = 1
              this.is_doc_submitted = 1;              
            }
            if (this.contract_documents.some((doc: any) => doc.need_more_documents == 1)) {
              this.need_more_documents = 1;
              this.is_doc_submitted = 1;
              
            }
            if (this.contract_documents.some((doc: any) => doc.is_pending == 1)) {
              this.is_pending = 1;
              this.is_doc_submitted = 0;
             
            }
            if (this.contract_documents.some((doc: any) => doc.doc_url != "" )) {
              this.is_any_doc_upload = true;
             
            }
            // this.doc_count = this.contract_documents.filter((doc: any) => {
            //   return doc.is_pending == 1
            // })
            // this.doc_count = this.doc_count.length ? this.doc_count.length : 0;
            this.doc_count = data.documents_required && data.documents_required.filter((doc: any) => doc.is_uploaded == 1).length;
            this.initials = this.contract_data.patient_first_name[0].toUpperCase() + this.contract_data.patient_last_name[0].toUpperCase()
            // if (window.location.search != '') {
            //   setTimeout(() => {
            //     if (params.get('type') == 'dispute' && data.contracts_list && data.contracts_list.length > 0) {
            //       let contract_data = { contract_id: data.contracts_list[0].contract_id, pp_id: data.contracts_list[0].pp_id, pp_subscription_id: data.contracts_list[0].pp_subscription_id, contract_code: data.contracts_list[0].contract_code, pp_code: data.contracts_list[0].payment_process_code, pp_subscription_code: data.contracts_list[0].pp_subscription_code, code: data.contracts_list[0].status.code }
            //       this.getContractDetailsDisputes(contract_data);
            //     }
            //   }, 200)
            // }
          } catch (error) {
            console.log(error);
          }
        })
      // }
    } catch (error) {
      console.log(error)
    }
  }

  fileSelect(showInput: any,document:any) {
    const modelRef = this._modalService.show(DisputeModalComponent, {
      initialState: {
        modalType: this._dispute.modalTypes.upload_doc,
        extra_data: {
          contract: 'contractData',
          fromPage: 'uploadDoc',
          showInput: showInput,
        },
      },
      class: 'modal-dialog-centered',
    });
    modelRef.content?.docData.subscribe((response) => {
      // if (!response.closed) {
      //  console.log(response,'ghscdfhgcfadhfasdv');
      //  response.mediaFile = response.uploadedFile;
      //  response.doc_name = response.new_doc_name 
      //  this.images.push({ file: response });
      //  const reader = this.readFiles(selectedFile);
      //  this.uploadFile(reader, this.images.length - 1, document.document_type_id,document.document_id,document.need_more_documents,document.document_name);
      // }
      // this.uploadDocument(docs, response);

      if (response && response.uploadedFile && response.uploadedFile) {
        
          let selectedFile = response.uploadedFile;
          if ((selectedFile.size / 1024 / 1024) > 10) {
            this._shared.customPopups('File size must be less than 10MB', 2);
            return false;
          }
          if (selectedFile.type.indexOf('image/') === 0 || selectedFile.type.indexOf('application/') === 0) {
            // let index = this.images.findIndex((x: any) => x.uploadedFile.name == selectedFile.name);;
            // const reader = this.readFiles(selectedFile);
            // if (index < 0) {
              // this.images.push({ file: response });
              // this.change_status_data.uploading = true;
              this.uploadFile(response, this.images.length - 1, document.document_type_id, document.document_id, document.need_more_documents, document.document_name);
              // this.imgElement.nativeElement.value = '';
            // }
          } else {
            this._shared.customPopups('Please select valid file', 2);
          }
        
      }
      return true;
    });
    
  }

  readFiles(file: any) {
    file.mediaFile = file.file;
    file.file = this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file.mediaFile));
    return file;
  }


  uploadFile(item: any, index?: any, document_type?: any,document_id ?: any,need_more_documents?:any,doc_name?: any) {
    // this.change_status_data.uploading = true;
    // this.images[index].uploading = true;
    const formData = new FormData();
    let code:any  = Object.values(this.viewId)[0];
    // doc_name = document_type == 13 ? doc_name : "";
    formData.append('document_file', item.uploadedFile);
    if (Object.keys(this.viewId)[0] == "contract_id") {
      formData.append('contract_id', code);
    }else{
      formData.append('split_req_id', code);
    }
   
    formData.append('document_type', document_type);
    formData.append('doc_name', doc_name);
    if (need_more_documents) {
       formData.append('document_id', document_id);      
       formData.append('is_reupload',"1");
    }

    this._api.uploadApi(formData, 'disputes/upload_dispute_document').subscribe((response: any) => {
      if ( response && !response.is_error) {
        this.is_doc_submitted = 0;
        this.doc_count += 1;
        // this.images[index].uploading = false;
        // this._loader.hideLoader();
        // this.images[index].image = response.body.uploaded_file_details.document_url;
        this.getcontractListFromId();
      } else if (response && response.body && response.body){
        // this.images[index].uploading = false;
        this._loader.hideLoader();
        this._shared.customPopups(response.body.original_text || 'Error in uploading file', 1);
      }
    });
  }

  // openRouteInNewTab(route: string) {
  //   const url = this.router.serializeUrl(this.router.createUrlTree([route]));
  //   window.open(url, '_blank');
  // }

  deleteDocument(id: number){
    const params = {
      document_id: id
    };
    this._api
      .api(params, 'disputes/delete_dispute_document')
      .subscribe((data: any) => {
        if (data && !data.is_error) {
          this.doc_count -= 1;
          this.is_doc_submitted = 1;
          this._shared.customPopups('Document Deleted Successfully.', 0);
          this.getcontractListFromId();
        } else {
          this._shared.customPopups(data.original_text, 1);
        }
      });
  }

  showDocumentUploadModal(showInput: boolean, docs?: any,document_id?:any) {
    const modelRef = this._modalService.show(DisputeModalComponent, {
      initialState: {
        modalType: this._dispute.modalTypes.addMoreDocuments,
        extra_data: {
          contract: 'contractData',
          fromPage: 'uploadDoc',
          showInput: showInput,
        },
      },
      class: 'modal-dialog-centered',
    });
    modelRef.content?.docData.subscribe((response) => {
     if (!response.closed) {
      console.log(response,'ghscdfhgcfadhfasdv');
      response.mediaFile = response.uploadedFile;
      response.doc_name = response.new_doc_name 
      this.images.push({ file: response });
      this.uploadFile(response,0,13,document_id,0,response.doc_name);
     }
      // this.uploadDocument(docs, response);
    });
  }

  submitDocuments() {
    this.doc_note = this.doc_note.trim();
    // if (!this.doc_note || this.doc_note == ' '){
    //   this._shared.customPopups('Please enter a valid note.', 1);
    //   return;
    // }
    const params = {
      contract_id: Object.values(this.viewId)[0],
      note: this.doc_note,
      split_req_id : Object.values(this.viewId)[0]
    };
    if (Object.keys(this.viewId)[0] == "contract_id") {
      delete params.split_req_id 
    }else{
      delete params.contract_id 
    }
    this._api
      .api(params, 'disputes/submit_documents')
      .subscribe((data: any) => {
        if (data && !data.is_error) {
          const modelRef = this._modalService.show(DisputeModalComponent, {
                initialState: {
                  modalType: this._dispute.modalTypes.submittion,
                  extra_data: {
                    doc_count: this.doc_count,
                    total_doc_count:this.contract_documents.length
                  },
                },
                class: 'modal-dialog-centered',
              });
              modelRef.content?.passEntry.subscribe((response: any) => {
                if (response && response.success) {
                  
                  this.router.navigate([`/app/disputes`]);
                  this._shared.customPopups('Documents Submitted Successfully.', 0);
                  
                }
              });
          
        } else {
          this._shared.customPopups(data.original_text, 1);
        }
      });
  }
}
